import React from 'react';
import { Link } from 'react-router-dom';
import projectArray from './projectArray';
import './All-Projects.css';

const Projects = () => {

    return (
        <div className="grenchi-all-projects">
            <h4 className='heading text-green'>OUR PROJECTS</h4>
            <div className="all-projects-container">
                {projectArray.map((projectArray) => (
                    <div key={projectArray.id} className='all-project' >
                        <Link to={projectArray.url}>
                            <div className="all-project-img"><img src={projectArray.image} alt={projectArray.title} /></div>
                            <div className="all-project-info bold">
                                <p>{projectArray.title}</p>
                            </div>
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Projects;